'use client';

import { useState } from 'react';

import { InvoiceForCurrencyForLegalEntity } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';

import { initialOpenInvoiceFilters, OpenInvoiceFilters as OpenInvoiceFiltersModel } from '../../../models/filters.model';

import { OpenInvoiceFilters } from './filters/open-invoice-filters';
import { OpenInvoiceList } from './open-invoice-list';

type Props = {
   openInvoices: InvoiceForCurrencyForLegalEntity[];
   isFilterToggleEnabled: boolean;
   canPayOnline: boolean;
   canDeductCreditNotes: boolean;
};

export const OpenInvoices = ({ openInvoices, isFilterToggleEnabled, canPayOnline, canDeductCreditNotes }: Props) => {
   const [filters, setFilters] = useState<OpenInvoiceFiltersModel>(initialOpenInvoiceFilters);

   return (
      <Box direction="column" gap="2xl">
         {isFilterToggleEnabled && <OpenInvoiceFilters filters={filters} openInvoices={openInvoices} onFiltersChange={setFilters} />}
         <OpenInvoiceList
            openInvoices={openInvoices}
            openInvoiceFilters={filters}
            canPayOnline={canPayOnline}
            canDeductCreditNotes={canDeductCreditNotes}
         />
      </Box>
   );
};
